import { render, staticRenderFns } from "./LoldocupEvent.vue?vue&type=template&id=ff3b9fbe&"
import script from "./LoldocupEvent.vue?vue&type=script&lang=js&"
export * from "./LoldocupEvent.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupEvent.vue?vue&type=style&index=0&id=ff3b9fbe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports